import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations'
import LogRocket from 'logrocket'
import { QueryClient, QueryClientProvider } from 'react-query'
import 'swiper/swiper-bundle.css'
import '@stripe/stripe-js'

import config from 'config'
import { AuthProvider } from 'contexts/AuthContext'
import { CustomerSupportProvider } from 'contexts/CustomerSupportContext'

import App from './app/index'
import { ErrorFallbackComponent, ScrollToTop } from 'components'

import './index.css'

const history = createBrowserHistory()
const {
  node_env,
  app_env,
  sentry: { dsn, release },
  logrocket: { app_id },
} = config

if (node_env === 'production') {
  if (dsn) {
    Sentry.init({
      dsn,
      release,
      environment: app_env,
      integrations: [
        new CaptureConsoleIntegration({
          levels: ['error'],
        }),
      ],
      beforeSend(event) {
        // Send logged user id to Sentry with the error info
        const id = localStorage.userId
        if (id) {
          event.user = { id }
        }
        return event
      },
    })
  }
  if (app_id) {
    LogRocket.init(app_id)
  }
}
const queryClient = new QueryClient()

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallbackComponent}>
      <CustomerSupportProvider>
        <Router history={history}>
          <ScrollToTop />
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </AuthProvider>
        </Router>
      </CustomerSupportProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)
